import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '../../shared/button.component';
import { renderDate } from '../../shared/dateHelpers';

class ConnectionRunStatusHeader extends PureComponent {
  static propTypes = {
    refreshAction: PropTypes.func.isRequired,
    lastUpdated: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  };

  handleRefresh = event => {
    event.preventDefault();
    this.props.refreshAction();
  };

  render() {
    const { lastUpdated } = this.props;

    const formattedLastUpdated = lastUpdated ? renderDate(lastUpdated) : null;

    return (
      <div className="connection-run-status-dashboard-header">
        <h5 className="connection-run-status-dashboard-header__title">Connection Run Status</h5>
        <div className="connection-run-status-dashboard-header__status">
          Updated: {formattedLastUpdated} <Button type="button" kind="primary" onClick={this.handleRefresh}>Refresh</Button>
        </div>
      </div>
    );
  }
}

export default ConnectionRunStatusHeader;
